import { useNavigate, useParams } from 'react-router'

import CoverImage from 'js/components/CoverImage'
import { Container } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import ItemActions from 'js/components/Item/ItemActions/ItemActions'
import Author from 'js/components/Item/ItemHeader/components/Author'
import ItemStatusTag from 'js/components/Item/ItemStatusTag'
import Section from 'js/components/Section/Section'
import TiptapView from 'js/components/Tiptap/TiptapView'
import type { MagazineIssueViewEntity } from 'js/magazine-issue/View/View.types'

import styles from './ArticlePage.module.css'

type ArticlePageProps = {
    container: MagazineIssueViewEntity
    entity: MagazineIssueViewEntity['articles'][number]
}

const ArticlePage = ({ container, entity }: ArticlePageProps) => {
    const params = useParams()
    const navigate = useNavigate()

    const { guid, title, richDescription, featured } = entity

    const onEdit = `/magazine-issue/edit/${params.containerGuid}/${guid}`

    const afterDelete = () => {
        navigate(container.url, {
            replace: true,
        })
    }

    return (
        <Section className={styles.wrapper}>
            <Container size="huge">
                <H1 className={styles.title}>
                    {title}
                    <ItemActions
                        entity={entity}
                        onEdit={onEdit}
                        onAfterDelete={afterDelete}
                        hideArchive={true}
                        className={styles.actions}
                        refetchQueries={['MagazineIssue', 'MagazineView']}
                    />
                    <ItemStatusTag
                        entity={entity}
                        style={{
                            marginTop: '8px',
                        }}
                    />
                </H1>

                <Author entity={entity} className={styles.author} />

                <CoverImage
                    featured={featured}
                    size="full"
                    borderRadius="16px"
                    className={styles.coverImage}
                />
            </Container>

            <Container size="normal">
                <TiptapView
                    content={richDescription}
                    textSize="large"
                    className={styles.content}
                />
            </Container>
        </Section>
    )
}

export default ArticlePage
